import { useCallback, useEffect } from 'react';
export const usePopoverClickListener = ({
  contentRef,
  onClose
}) => {
  const contentEl = contentRef.current;
  const handleWindowClick = useCallback(evt => {
    const clickTarget = evt.target;
    if (contentEl && !contentEl.contains(clickTarget)) {
      return onClose();
    }
    return true;
  }, [contentEl, onClose]);
  useEffect(() => {
    if (contentEl && contentEl instanceof HTMLDivElement) {
      const parentList = contentEl.closest('ul');
      if (parentList) {
        parentList.addEventListener('click', handleWindowClick);
      }
    }
  }, /* eslint-disable react-hooks/exhaustive-deps */[contentEl]);
};